var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./Loader.styles.scss";
var Spinner = function () { return _jsx("span", { className: "mp-spinner" }); };
var Bounce = function (_a) {
    var caption = _a.caption;
    return (_jsxs("div", { children: [caption && _jsx("p", __assign({ className: "mp-loader-caption" }, { children: caption })), _jsxs("div", __assign({ className: "mp-bounce-loader" }, { children: [_jsx("div", { className: "mp-bounce1" }), _jsx("div", { className: "mp-bounce2" }), _jsx("div", { className: "mp-bounce3" })] }))] }));
};
export var Loader = function (_a) {
    var caption = _a.caption, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.loaderType, loaderType = _c === void 0 ? "spinner" : _c;
    return (_jsx("div", __assign({ className: "".concat(className, " mp-loader-wrapper") }, { children: loaderType === "spinner" ? _jsx(Spinner, {}) : _jsx(Bounce, { caption: caption }) })));
};
